import { createContext, useContext, useState, ReactNode } from 'react';

interface HelpDrawerContextType {
  isOpen: boolean;
  openDrawer: () => void;
  closeDrawer: () => void;
  toggleDrawer: () => void;
}

const HelpDrawerContext = createContext<HelpDrawerContextType | undefined>(undefined);

export const useHelpDrawer = () => {
  const context = useContext(HelpDrawerContext);
  if (!context) {
    throw new Error('useHelpDrawer must be used within a HelpDrawerProvider');
  }
  return context;
};

interface HelpDrawerProviderProps {
  children: ReactNode;
}

export const HelpDrawerProvider: React.FC<HelpDrawerProviderProps> = ({ children }) => {
  const [isOpen, setIsOpen] = useState(false);

  const openDrawer = () => setIsOpen(true);
  const closeDrawer = () => setIsOpen(false);
  const toggleDrawer = () => setIsOpen(prev => !prev);

  return (
    <HelpDrawerContext.Provider value={{ isOpen, openDrawer, closeDrawer, toggleDrawer }}>
      {children}
    </HelpDrawerContext.Provider>
  );
};

